import * as API from "utils/api";
import HTTPStatus from "http-status";

const getCountiesRequest = () => ({
  type: "GET_COUNTIES_REQUEST"
});

const getCountiesSuccess = counties => ({
  type: "GET_COUNTIES_SUCCESS",
  counties
});

const getCountiesFailure = () => ({
  type: "GET_COUNTIES_FAILURE"
});

const getCountySuccess = county => ({
  type: "GET_COUNTY_SUCCESS",
  county
});

const getCountyFailure = () => ({
  type: "GET_COUNTY_FAILURE"
});

export const getCounties = () => async dispatch => {
  dispatch(getCountiesRequest());
  const response = await API.get("/counties");
  switch (response.status) {
    case HTTPStatus.OK:
      const counties = await response.json();
      dispatch(getCountiesSuccess(counties))
      break
    default:
      dispatch(getCountiesFailure());
      break
  }
};

export const getCounty = id => async dispatch => {
  const response = await API.get(`/counties/${id}`)

  switch (response.status) {
    case HTTPStatus.OK:
      const county = await response.json()
      dispatch(getCountySuccess(county))
      break
    default:
      dispatch(getCountyFailure())
      break
  }
}


// WEBPACK FOOTER //
// src/data/counties/actions.js